import { render, staticRenderFns } from "./IdentityAuth.vue?vue&type=template&id=65e0b89a&scoped=true&"
import script from "./IdentityAuth.vue?vue&type=script&lang=js&"
export * from "./IdentityAuth.vue?vue&type=script&lang=js&"
import style0 from "./IdentityAuth.vue?vue&type=style&index=0&id=65e0b89a&lang=less&scoped=true&"
import style1 from "./IdentityAuth.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e0b89a",
  null
  
)

export default component.exports